<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="title">申请单信息</div>
      <blue-title class="style">营业执照</blue-title>
      <div>
        <div class="info">
          <span class="marRight">已选服务商</span><span>{{ allData.merchantType }}</span>
        </div>
        <div class="info">
          <span class="marRight">已选主体类型</span><span>{{ allData.subjectType }}</span>
        </div>
        <div class="info">
          <span class="marRight">创建时间</span><span>{{ allData.createTime }}</span>
        </div>
        <div class="info">
          <span class="marRight">申请单编号</span><span>{{ allData.applymentId }}</span>
        </div>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="next">下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { draftEcho } from '../../../../api/module/merchants';
export default {
  components: {},
  props: {},
  data() {
    return {
      allData: {},
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
  },
  watch: {},
  created() {
    this.draftEcho();
  },
  methods: {
    back() {
      this.$router.push({
        path: '/merchants',
      });
    },
    next() {
      const { uuid } = this;
      this.$router.push({
        path: '/merchants/subjectDetails',
        query: {
          uuid,
        },
      });
    },
    async draftEcho() {
      const { uuid } = this;
      const result = await draftEcho({
        uuid,
      });
      this.allData = result.listVO;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  .title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 9px 0 20px 0;
  }
  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .marRight {
    width: 90px;
    margin-right: 38px;
  }
  .btn {
    margin-top: 200px;
  }
}
</style>
